import gql from 'graphql-tag';

export const FeedbackCreate = gql`
  mutation feedbackCreate($input: FeedbackCreateInput!) {
    feedbackCreate(input: $input) {
      success
    }
  }
`;
